<template>
 <div>
  <json-view :data="transaction" :maxDepth="3" rootKey="transaction"/>
 </div>
</template>

<script>
import { mapGetters } from "vuex";
import { JSONView } from "vue-json-component";

export default {
  name: "TransactionViewForm",
  components: { "json-view": JSONView },
  data() {
    return {
     
    };
  },
  computed: {
    ...mapGetters(["transaction", "userPermissions"]),
  },
  mounted() {
   
  },

  methods: {
  },
};
</script>

<style lang="scss">
</style>